import {Icon, IconProps} from '@chakra-ui/icon';
import {useBreakpointValue} from '@chakra-ui/media-query';

const ProfileIcon = (props: IconProps) => {
  const strokeWidth = useBreakpointValue(['1', null, null, '1.5']) as string;

  return (
    <Icon boxSize={6} viewBox="0 0 25 24" strokeWidth={strokeWidth} {...props}>
      <path
        d="M19.5 18.5C19.5 20.0294 16.5 21 12.5 21C8.5 21 5.5 20.0294 5.5 18.5C5.5 16.2692 9 15 12.5 15C16 15 19.5 16.5 19.5 18.5Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 12C14.9853 12 17 9.98528 17 7.5C17 5.01472 14.9853 3 12.5 3C10.0147 3 8 5.01472 8 7.5C8 9.98528 10.0147 12 12.5 12Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

const HomeIcon = ({active, ...props}: IconProps & {active: boolean}) => {
  return (
    <Icon boxSize={6} viewBox="0 0 25 24" fill="none" {...props}>
      <path
        d="M21.5 15.3969C21.5 19.9329 20.5 20.4329 12.5 20.4329C4.50003 20.4329 3.49999 19.4329 3.50003 15.3969C3.50006 13.2556 3.5 13.7515 3.5 11.8773C3.5 10.003 4.07474 8.93288 7.44411 6.22235C8.85369 5.0884 10.0725 4.17162 10.9601 3.52398C11.8925 2.84364 13.1264 2.81735 14.0609 3.49475C14.8853 4.09227 16.044 4.97476 17.5559 6.22235C21 9.06446 21.5 9.93288 21.5 11.8773C21.4999 15.6374 21.5 12.2556 21.5 15.3969Z"
        fill={active ? '#2A2E3A' : 'none'}
        stroke={active ? '#5AC57B' : '#6C6C6C'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 17.4329C9.875 15.9329 9.5 14.4329 12.5 14.4329C15.5 14.4329 15.125 15.9329 15.5 17.4329"
        stroke={active ? '#5AC57B' : '#6C6C6C'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export const NotificationsIcon = ({newNotifications, ...props}: IconProps & {newNotifications: boolean}) => {
  const badgeStroke = useBreakpointValue(['white', null, null, '#191B20']) as string;
  const strokeWidth = useBreakpointValue(['1', null, null, '1.5']) as string;
  return (
    <Icon width="24px" height="24px" viewBox="0 0 25 24" stroke="#2A2E3A" fill="none" {...props}>
      <path
        d="M10.5 20C10.5 20 11.1667 21 12.5 21C13.8333 21 14.5 20 14.5 20"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      />
      <path
        d="M18.5 9C18.5 11 20.5 12 20.5 14C20.5 17 16.0556 18 12.5 18C8.94445 18 4.5 17 4.5 14C4.5 12 6.5 11.2414 6.5 9C6.5 6 8.50001 3 12.5 3C16.5 3 18.5 6 18.5 9Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {newNotifications && <circle cx="17.5" cy="7" r="4" fill="#EC1958" stroke={badgeStroke} strokeWidth="2" />}
    </Icon>
  );
};

const LanguageSwitchIcon = ({lang}: {lang: 'en' | 'ar'}) => {
  return (
    <Icon boxSize="8" viewBox="0 0 32 32" fill="none">
      {lang === 'ar' ? (
        <path
          d="M16.1787 24C14.5213 24 13.2329 23.6174 12.3134 22.8523C11.4052 22.0872 10.9512 21.007 10.9512 19.6118C10.9512 18.7229 11.2066 17.924 11.7174 17.2152C12.2396 16.5063 13.0683 15.8819 14.2035 15.3418V15.2574C13.4997 14.8298 12.9832 14.3572 12.654 13.8397C12.3361 13.3108 12.1772 12.7145 12.1772 12.0506C12.1772 11.5331 12.268 11.0323 12.4496 10.5485C12.6313 10.0534 12.8923 9.62025 13.2329 9.24895C13.5848 8.86639 14.0048 8.56259 14.493 8.33755C14.9925 8.11252 15.5544 8 16.1787 8C17.0188 8 17.7339 8.19128 18.3242 8.57384C18.9145 8.9564 19.3913 9.4571 19.7546 10.076L17.9326 11.6793C17.6829 11.2855 17.3934 10.9986 17.0642 10.8186C16.735 10.6273 16.3263 10.5316 15.8382 10.5316C15.2252 10.5316 14.7427 10.661 14.3908 10.9198C14.0502 11.1786 13.88 11.5612 13.88 12.0675C13.88 13.1027 14.7257 13.6203 16.4171 13.6203C16.735 13.6203 17.0755 13.6034 17.4388 13.5696C17.802 13.5359 18.205 13.4796 18.6478 13.4008L20.01 13.1646L20.4016 15.4937L18.171 15.865C16.3206 16.1688 14.9697 16.5851 14.1184 17.1139C13.267 17.6428 12.8413 18.3347 12.8413 19.1899V19.3924C12.8413 20.1013 13.1364 20.6245 13.7267 20.962C14.317 21.2996 15.1344 21.4684 16.1787 21.4684C16.9961 21.4684 17.802 21.3221 18.5967 21.0295C19.4027 20.7482 20.0951 20.3432 20.6741 19.8143L21.9512 21.8059C21.236 22.4923 20.3733 23.0267 19.3629 23.4093C18.3526 23.8031 17.2912 24 16.1787 24Z"
          fill="#5AC57B"
        />
      ) : (
        <>
          <path
            d="M15.3648 15.6623C15.3648 15.9478 15.3483 16.2498 15.3153 16.5683H8.10032C8.15523 17.4578 8.45722 18.1552 9.00631 18.6603C9.56638 19.1545 10.2418 19.4016 11.0325 19.4016C11.6804 19.4016 12.2185 19.2533 12.6468 18.9568C13.086 18.6493 13.3935 18.243 13.5692 17.7379H15.1836C14.942 18.6054 14.4588 19.3137 13.734 19.8628C13.0092 20.4009 12.1087 20.67 11.0325 20.67C10.1759 20.67 9.40715 20.4778 8.72628 20.0934C8.05639 19.7091 7.52926 19.1655 7.1449 18.4626C6.76054 17.7488 6.56836 16.9252 6.56836 15.9918C6.56836 15.0583 6.75505 14.2402 7.12843 13.5373C7.50181 12.8345 8.02344 12.2964 8.69333 11.923C9.3742 11.5386 10.1539 11.3465 11.0325 11.3465C11.889 11.3465 12.6468 11.5331 13.3057 11.9065C13.9646 12.2799 14.4697 12.7961 14.8212 13.455C15.1836 14.1029 15.3648 14.8387 15.3648 15.6623ZM13.8163 15.3493C13.8163 14.7783 13.69 14.2896 13.4375 13.8832C13.1849 13.4659 12.839 13.153 12.3997 12.9443C11.9714 12.7247 11.4937 12.6149 10.9666 12.6149C10.2088 12.6149 9.56089 12.8565 9.02279 13.3397C8.49566 13.8228 8.19366 14.4927 8.11679 15.3493H13.8163Z"
            fill="#5AC57B"
          />
          <path
            d="M21.7416 11.33C22.8398 11.33 23.7293 11.6649 24.4102 12.3348C25.091 12.9937 25.4315 13.9491 25.4315 15.2011V20.5217H23.9489V15.4152C23.9489 14.5147 23.7238 13.8283 23.2736 13.3561C22.8233 12.8729 22.2083 12.6313 21.4286 12.6313C20.6379 12.6313 20.0065 12.8784 19.5343 13.3726C19.073 13.8668 18.8424 14.5861 18.8424 15.5305V20.5217H17.3434V11.4947H18.8424V12.7796C19.1389 12.3183 19.5398 11.9614 20.0449 11.7089C20.5611 11.4563 21.1266 11.33 21.7416 11.33Z"
            fill="#5AC57B"
          />
        </>
      )}
      <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="url(#paint0_linear_1068_5578)" />
      <defs>
        <linearGradient
          id="paint0_linear_1068_5578"
          x1="16.4512"
          y1="0"
          x2="16.4512"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5AC57B" />
          <stop offset="1" stopColor="#7A7A7A" />
        </linearGradient>
      </defs>
    </Icon>
  );
};

const EarnedBadges = (props: IconProps) => (
  <Icon width="22px" height="23px" viewBox="0 0 22 23" fill="none" {...props}>
    <path
      d="M10.1077 1.32735C10.7265 0.970084 11.4889 0.970085 12.1077 1.32735L20.3619 6.0929C21.0527 6.49176 21.4405 7.26303 21.3485 8.05545L20.2469 17.5503C20.1613 18.288 19.6739 18.9176 18.9811 19.1853L11.7967 21.9613C11.3172 22.1466 10.7848 22.1402 10.3099 21.9433L3.64278 19.1791C2.99974 18.9125 2.54159 18.3308 2.43316 17.6432L0.92935 8.1068C0.800448 7.28937 1.18828 6.47698 1.90494 6.06322L10.1077 1.32735Z"
      fill="url(#paint0_linear_4_696)"
      fillOpacity="0.2"
      stroke="url(#paint1_linear_4_696)"
      strokeWidth="0.5"
    />
    <path
      d="M10.5501 11.1626L13.0144 6.16319L10.7714 5.94761L8.18169 12.5446L11.1723 12.8321L9.6426 17.9213L13.5407 11.45L10.5501 11.1626Z"
      fill="url(#paint2_linear_4_696)"
      stroke="url(#paint3_linear_4_696)"
      strokeWidth="0.5"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4_696"
        x1="0.715393"
        y1="11.5"
        x2="21.5"
        y2="11.4981"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AA6535" />
        <stop offset="1" stopColor="#FBBF95" />
      </linearGradient>

      <linearGradient
        id="paint1_linear_4_696"
        x1="0.715393"
        y1="11.5"
        x2="21.5"
        y2="11.4981"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AA6535" />
        <stop offset="1" stopColor="#FBBF95" />
      </linearGradient>

      <linearGradient
        id="paint2_linear_4_696"
        x1="8.24443"
        y1="11.7458"
        x2="13.4852"
        y2="12.1573"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AA6535" />
        <stop offset="1" stopColor="#FBBF95" />
      </linearGradient>

      <linearGradient
        id="paint3_linear_4_696"
        x1="8.24443"
        y1="11.7458"
        x2="13.4852"
        y2="12.1573"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#AA6535" />
        <stop offset="1" stopColor="#FBBF95" />
      </linearGradient>
    </defs>
  </Icon>
);

const Logo = (props: IconProps) => (
  <Icon width="53px" height="14px" viewBox="0 0 53 14" fill="none" {...props}>
    <mask id="mask0_18_2552" maskUnits="userSpaceOnUse" x="0" y="0" width="53" height="14">
      <path
        d="M5.07751 3.83094C5.74894 3.83094 6.37986 3.95828 6.97026 4.21296C7.56066 4.46765 8.07581 4.81494 8.51572 5.25484C8.95562 5.69475 9.30292 6.2099 9.5576 6.8003C9.81228 7.3907 9.93962 8.02162 9.93962 8.69306V9.56129H4.38292C4.42923 9.74651 4.51605 9.90858 4.64339 10.0475C4.74758 10.1748 4.90386 10.2848 5.11224 10.3774C5.32061 10.47 5.59845 10.5163 5.94574 10.5163C6.1657 10.5163 6.36828 10.4816 6.55351 10.4122C6.75031 10.3427 6.91817 10.2617 7.05708 10.1691C7.21915 10.0649 7.36965 9.9491 7.50856 9.82176L8.98456 12.166C8.72988 12.4207 8.41732 12.6522 8.04687 12.8606C7.73431 13.0342 7.35228 13.1905 6.9008 13.3294C6.44932 13.4799 5.92838 13.5552 5.33798 13.5552C4.59708 13.5552 3.91407 13.4278 3.28894 13.1731C2.66382 12.9185 2.11972 12.5712 1.65666 12.1313C1.20518 11.6914 0.852099 11.1762 0.597416 10.5858C0.342734 9.99541 0.215393 9.36449 0.215393 8.69306C0.215393 8.02162 0.342734 7.3907 0.597416 6.8003C0.852099 6.2099 1.19939 5.69475 1.6393 5.25484C2.0792 4.81494 2.59436 4.46765 3.18476 4.21296C3.77516 3.95828 4.40607 3.83094 5.07751 3.83094ZM5.85892 7.91164C5.85892 7.56435 5.78367 7.30388 5.63318 7.13023C5.48268 6.95659 5.29746 6.86976 5.07751 6.86976C4.85755 6.86976 4.67233 6.95659 4.52184 7.13023C4.37134 7.30388 4.2961 7.56435 4.2961 7.91164H5.85892Z"
        fill="white"
      />
      <path
        d="M18.8538 8.60623L21.6322 13.2947H17.0305L15.2941 9.64811V13.2947H11.1265V0.444824H15.2941V7.56435L16.7701 4.09141H21.2849L18.8538 8.60623Z"
        fill="white"
      />
      <path
        d="M30.0112 10.5163C30.0112 10.9331 29.9244 11.3267 29.7507 11.6971C29.5771 12.056 29.3166 12.3744 28.9693 12.6522C28.6336 12.93 28.211 13.15 27.7017 13.3121C27.1923 13.4741 26.6019 13.5552 25.9305 13.5552C25.2012 13.5552 24.5702 13.4683 24.0377 13.2947C23.5052 13.1326 23.0537 12.9474 22.6833 12.739C22.2549 12.4959 21.8903 12.2181 21.5893 11.9055L22.8917 9.82176C23.0653 9.98383 23.2621 10.1285 23.482 10.2559C23.6789 10.3716 23.9046 10.4758 24.1593 10.5684C24.4255 10.6495 24.7265 10.69 25.0622 10.69C25.1896 10.69 25.2938 10.6553 25.3748 10.5858C25.4558 10.5163 25.4964 10.4353 25.4964 10.3427C25.4964 10.2617 25.4095 10.1806 25.2359 10.0996C25.0738 10.0186 24.8654 9.92595 24.6108 9.82176C24.3676 9.71757 24.0956 9.59602 23.7946 9.4571C23.5052 9.30661 23.2332 9.12138 22.9785 8.90143C22.7354 8.6699 22.527 8.39207 22.3533 8.06793C22.1913 7.73221 22.1102 7.33282 22.1102 6.86976C22.1102 6.45301 22.1971 6.0652 22.3707 5.70633C22.5444 5.33588 22.799 5.01174 23.1348 4.7339C23.482 4.45607 23.9104 4.23612 24.4197 4.07405C24.9291 3.91198 25.5195 3.83094 26.1909 3.83094C26.7813 3.83094 27.3081 3.91198 27.7711 4.07405C28.2458 4.22454 28.6509 4.3924 28.9867 4.57762C29.3687 4.786 29.7102 5.0291 30.0112 5.30694L28.7088 7.3907C28.5699 7.26336 28.4136 7.1476 28.24 7.04341C28.0895 6.9508 27.91 6.86976 27.7017 6.8003C27.5049 6.73084 27.2907 6.69612 27.0592 6.69612C26.9318 6.69612 26.8276 6.73084 26.7466 6.8003C26.6656 6.86976 26.6251 6.9508 26.6251 7.04341C26.6251 7.13602 26.7061 7.22284 26.8682 7.30388C27.0418 7.37334 27.2502 7.46016 27.4933 7.56435C27.748 7.66854 28.02 7.79588 28.3094 7.94637C28.6104 8.08529 28.8825 8.27051 29.1256 8.50204C29.3803 8.722 29.5886 8.99983 29.7507 9.33555C29.9244 9.65969 30.0112 10.0533 30.0112 10.5163Z"
        fill="white"
      />
      <path
        d="M35.2666 3.83094C36.0075 3.83094 36.6905 3.95828 37.3156 4.21296C37.9407 4.46765 38.479 4.81494 38.9305 5.25484C39.3936 5.69475 39.7525 6.2099 40.0071 6.8003C40.2618 7.3907 40.3892 8.02162 40.3892 8.69306V13.2947H36.3953L36.048 12.2528C35.8975 12.4959 35.7181 12.7159 35.5097 12.9127C35.3245 13.0747 35.0871 13.2195 34.7977 13.3468C34.5199 13.4857 34.1842 13.5552 33.7906 13.5552C33.3159 13.5552 32.8818 13.4799 32.4882 13.3294C32.1062 13.1905 31.7763 12.9937 31.4984 12.739C31.2322 12.4843 31.0238 12.1834 30.8733 11.8361C30.7344 11.4888 30.6649 11.1067 30.6649 10.69C30.6649 10.2732 30.7402 9.89122 30.8907 9.54393C31.0527 9.19663 31.3016 8.89564 31.6374 8.64096C31.9731 8.38628 32.4014 8.18948 32.9223 8.05056C33.4549 7.90007 34.0916 7.82482 34.8325 7.82482H36.2216C36.1753 7.65117 36.0885 7.49489 35.9612 7.35597C35.8454 7.22863 35.6833 7.11866 35.4749 7.02604C35.2781 6.92186 35.0061 6.86976 34.6588 6.86976C34.4389 6.86976 34.2305 6.90449 34.0337 6.97395C33.8485 7.04341 33.6864 7.12444 33.5475 7.21706C33.3854 7.32124 33.2349 7.43701 33.096 7.56435L31.62 5.22012C31.8747 4.96543 32.1872 4.7339 32.5577 4.52553C32.8702 4.35188 33.2523 4.1956 33.7038 4.05668C34.1552 3.90619 34.6762 3.83094 35.2666 3.83094ZM35.3534 10.7768C35.5733 10.7768 35.7701 10.6611 35.9438 10.4295C36.129 10.198 36.2216 9.82176 36.2216 9.30082C35.7354 9.30082 35.3823 9.39343 35.1624 9.57865C34.9424 9.76388 34.8325 9.98962 34.8325 10.2559C34.8325 10.3832 34.8846 10.5048 34.9887 10.6205C35.1045 10.7247 35.2261 10.7768 35.3534 10.7768Z"
        fill="white"
      />
      <path
        d="M52.1645 8.69306C52.1645 9.48026 52.0603 10.1748 51.8519 10.7768C51.6551 11.3788 51.3888 11.8882 51.0531 12.3049C50.7174 12.7101 50.3296 13.0227 49.8897 13.2426C49.4498 13.451 48.9925 13.5552 48.5179 13.5552C48.078 13.5552 47.7017 13.4857 47.3892 13.3468C47.0882 13.2195 46.8393 13.0747 46.6425 12.9127C46.411 12.7159 46.2257 12.4959 46.0868 12.2528L45.7395 13.2947H41.9193V0.444824H46.0868V5.13329C46.2257 4.90176 46.411 4.6876 46.6425 4.4908C46.8393 4.32873 47.0882 4.17823 47.3892 4.03932C47.7017 3.9004 48.078 3.83094 48.5179 3.83094C48.9925 3.83094 49.4498 3.94092 49.8897 4.16087C50.3296 4.36925 50.7174 4.68181 51.0531 5.09856C51.3888 5.50374 51.6551 6.0131 51.8519 6.62666C52.0603 7.22863 52.1645 7.91743 52.1645 8.69306ZM47.8233 8.69306C47.8233 8.25315 47.7307 7.92901 47.5454 7.72063C47.3602 7.50068 47.1345 7.3907 46.8682 7.3907C46.602 7.3907 46.3762 7.50068 46.191 7.72063C46.0058 7.92901 45.9132 8.25315 45.9132 8.69306C45.9132 9.13296 46.0058 9.46289 46.191 9.68284C46.3762 9.89122 46.602 9.99541 46.8682 9.99541C47.1345 9.99541 47.3602 9.89122 47.5454 9.68284C47.7307 9.46289 47.8233 9.13296 47.8233 8.69306Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_18_2552)">
      <rect x="0.289612" y="-0.348358" width="52.0941" height="16.7445" fill="#5AC57B" />
    </g>
  </Icon>
);

export const icons = {Logo, ProfileIcon, HomeIcon, NotificationsIcon, LanguageSwitchIcon, EarnedBadges};
